import { ListReducerState, ApiAction } from '../../../../../types';
import { createByIds, createIds } from '../../../../../services/utils';

import { Elevator } from '../../../types';
import { fetchMaintenancesTypes } from '../../actions';

const initialState: ListReducerState<Elevator, Elevator['id']> = {
    byIds: {},
    ids: [],
};

export default (state = initialState, action: ApiAction) => {
    switch (action.type) {
        case fetchMaintenancesTypes.FETCH_MAINTENANCES_SUCCESS: {
            const maintenances: Elevator[] = action.payload;

            return {
                byIds: createByIds(maintenances),
                ids: createIds(maintenances),
            };
        }

        case fetchMaintenancesTypes.FETCH_MAINTENANCES_RESET:
            return initialState;

        default:
            return state;
    }
};
